import React from "react";
import "./MCTypeAbout.css";
import MCTypeAboutLogo from "../../../assets/mctypelogo.png";

function MCTypeAbout() {
  return (
    <div className="mc-type-about-container">
      <div className="mc-type-about-content">
        <a href="http://mctype.com/" target="_blank" rel="noopener noreferrer">
          <div className="mc-type-about-logo-container">
            <img
              src={MCTypeAboutLogo}
              alt="MCTypeAboutLogo"
              className="mc-type-about-logo"
            />
          </div>
        </a>

        <div className="mc-type-about-text-container">
          <h1 className="mc-type-about-main-title">MCType.com</h1>
          <p className="mc-type-about-descriptions">
            Uncover the realm of MCType.com, a haven dedicated to the symphony
            of mechanized marvels. Visualize an arena where the thrill of
            acceleration converges with the precision of artistry.
            <br />
            <br />
            Our curated collection of motorcycles, bicycles, and e-bikes
            transcends a mere catalog; it embodies an anthology of mechanical
            poetry.
            <br />
            <br />
            Immerse yourself in intricate specifications, decode performance
            subtleties, and embrace a narrative where every ride unravels a
            unique story.
            <br />
            <br />
            MCType.com extends an invitation to a world where trust isn't just
            earned; it's etched into every curve and resonates with every
            revolution.
          </p>
        </div>
      </div>
    </div>
  );
}

export default MCTypeAbout;
